<div class="settings-page">
    <!-- Header Section -->
    <header class="dashboard-header">
        <div class="left-section">
            <h1 class="dashboard-title">Settings</h1>
        </div>

        <div class="right-header-actions">
            <!-- <button class="header-action-btn widgets-btn">
                <span class="icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <rect x="3" y="3" width="7" height="7" rx="1.5"></rect>
                        <rect x="14" y="3" width="7" height="7" rx="1.5"></rect>
                        <rect x="14" y="14" width="7" height="7" rx="1.5"></rect>
                        <rect x="3" y="14" width="7" height="7" rx="1.5"></rect>
                    </svg>
                </span>
                <span class="text">Widgets</span>
            </button> -->
            <button class="header-action-btn notification-btn" (click)="toggleNotifications()">
                <img src="assets/icons/img-notification.svg" class="bell-icon" alt="Notifications" />
            </button>
        </div>
    </header>

    <div class="settings-container">
        <!-- Sidebar -->
        <aside class="settings-sidebar">
            <nav class="sidebar-nav">
                <button (click)="setTab('general')" [class.active]="activeTab === 'general'" class="nav-item">
                    <span class="nav-icon">
                        <img src="assets/icons/setting.svg" alt="General" width="18" height="18">
                    </span>
                    <span class="nav-text">General</span>
                </button>
                <button (click)="setTab('account')" [class.active]="activeTab === 'account'" class="nav-item">
                    <span class="nav-icon">
                        <img src="assets/icons/img_user.svg" alt="Account" width="18" height="18">
                    </span>
                    <span class="nav-text">Account</span>
                </button>
                <button (click)="setTab('notifications')" [class.active]="activeTab === 'notifications'"
                    class="nav-item">
                    <span class="nav-icon">
                        <img src="assets/icons/img-notification.svg" alt="Notifications" width="18" height="18">
                    </span>
                    <span class="nav-text">Notifications</span>
                </button>
                <button (click)="setTab('banks')" [class.active]="activeTab === 'banks'" class="nav-item connect-btn">
                    <span class="nav-icon">
                        <img src="assets/icons/img-bank.svg" alt="Банки" width="18" height="18">
                    </span>
                    <span class="nav-text">Connect</span>
                </button>
            </nav>
        </aside>

        <!-- Main Content -->
        <main class="settings-main-content">
            <!-- Header Section (Dynamic Title) -->
            <div class="main-header">
                <h1 *ngIf="activeTab === 'general'">General</h1>
                <h1 *ngIf="activeTab === 'account'">Account</h1>
                <h1 *ngIf="activeTab === 'notifications'">Notifications</h1>
                <h1 *ngIf="activeTab === 'banks'">Connected Banks</h1>

                <p *ngIf="activeTab === 'general'">Manage your personal information and preferences.</p>
                <p *ngIf="activeTab === 'account'">Manage your personal details and account preferences.</p>
                <p *ngIf="activeTab === 'notifications'">Control which alerts and updates you receive. Critical security
                    notifications will always be delivered.</p>
                <p *ngIf="activeTab === 'banks'">Manage the banks linked to your account. You can disable access at any
                    time.</p>
            </div>

            <div class="tab-content">
                <!-- General Tab -->
                <div *ngIf="activeTab === 'general'" class="general-section">
                    <div class="settings-card main-settings-card">
                        <!-- Edit Profile Section -->
                        <h2 class="card-title">Edit Profile</h2>

                        <div class="avatar-edit-section">
                            <input #avatarInput type="file" id="avatarInput" hidden (change)="onFileSelected($event)"
                                accept="image/*">
                            <div class="avatar-display" (click)="onAvatarClick()">
                                <div class="avatar-circle">
                                    <span *ngIf="!userInfo.avatar && !selectedImage">M</span>
                                    <img *ngIf="selectedImage" [src]="selectedImage" alt="Avatar Preview">
                                    <img *ngIf="!selectedImage && userInfo.avatar" [src]="userInfo.avatar" alt="Avatar">
                                    <!-- Overlay for preview and remove -->
                                    <div class="avatar-overlay" *ngIf="userInfo.avatar || selectedImage"
                                        (click)="$event.stopPropagation()">
                                        <button class="avatar-action-btn"
                                            (click)="openCropModalWithExisting(); $event.stopPropagation()"
                                            title="Crop photo">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path>
                                                <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>
                                            </svg>
                                        </button>
                                        <button class="avatar-action-btn remove"
                                            (click)="removeAvatar(); $event.stopPropagation()" title="Remove photo">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <path d="M18 6L6 18M6 6l12 12"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div class="camera-icon-badge">
                                    <div style="width: 20px; height: 30px; position: relative;">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M23 19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V8C1 6.89543 1.89543 6 3 6H7L9 3H15L17 6H21C22.1046 6 23 6.89543 23 8V19Z"
                                                fill="black" />
                                            <circle cx="12" cy="13.5" r="3.5" fill="white" />
                                            <circle cx="12" cy="13.5" r="2.5" fill="black" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <span class="profile-name">{{ userInfo.firstName }} {{ userInfo.lastName }}</span>
                        </div>

                        <div class="form-row">
                            <div class="form-group">
                                <label>First name</label>
                                <div class="input-with-icon">
                                    <input type="text" [(ngModel)]="userInfo.firstName" placeholder="First Name">
                                    <span class="edit-icon">
                                        <img src="assets/icons/penciledit.svg" alt="Edit" width="20" height="20">
                                    </span>
                                </div>
                                <div class="validation-error" *ngIf="validationErrors['firstName']">{{
                                    validationErrors['firstName'] }}</div>
                            </div>
                            <div class="form-group">
                                <label>Last Name</label>
                                <div class="input-with-icon">
                                    <input type="text" [(ngModel)]="userInfo.lastName" placeholder="Last Name">
                                    <span class="edit-icon">
                                        <img src="assets/icons/penciledit.svg" alt="Edit" width="20" height="20">
                                    </span>
                                </div>
                                <div class="validation-error" *ngIf="validationErrors['lastName']">{{
                                    validationErrors['lastName'] }}</div>
                            </div>
                        </div>

                        <div class="card-separator"></div>

                        <!-- General Section -->
                        <h2 class="card-title">General</h2>

                        <div class="settings-control-row">
                            <span class="control-label">Language</span>
                            <div class="custom-dropdown" (click)="toggleLanguageDropdown($event)">
                                <div class="selected-value">
                                    {{ selectedLanguage }}
                                    <div style="width: 16px; height: 16px; position: relative; overflow: hidden">
                                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none"
                                            stroke="currentColor" stroke-width="2.5">
                                            <path d="M6 9l6 6 6-6"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="dropdown-options" *ngIf="showLanguageDropdown">
                                    <div class="option" (click)="selectLanguage('English'); $event.stopPropagation()">
                                        English <svg *ngIf="selectedLanguage === 'English'" width="14" height="14"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                                            <path d="M20 6L9 17l-5-5"></path>
                                        </svg>
                                    </div>
                                    <div class="option" (click)="selectLanguage('Indian'); $event.stopPropagation()">
                                        Indian <svg *ngIf="selectedLanguage === 'Indian'" width="14" height="14"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                                            <path d="M20 6L9 17l-5-5"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="settings-control-row">
                            <span class="control-label">Theme</span>
                            <div class="custom-dropdown" (click)="toggleThemeDropdown($event)">
                                <div class="selected-value">
                                    {{ selectedTheme }}
                                    <div style="width: 16px; height: 16px; position: relative; overflow: hidden">
                                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none"
                                            stroke="currentColor" stroke-width="2.5">
                                            <path d="M6 9l6 6 6-6"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="dropdown-options" *ngIf="showThemeDropdown">
                                    <div class="option" (click)="selectTheme('System'); $event.stopPropagation()">System
                                    </div>
                                    <div class="option" (click)="selectTheme('Light'); $event.stopPropagation()">Light
                                    </div>
                                    <div class="option" (click)="selectTheme('Dark'); $event.stopPropagation()">Dark
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Account Tab -->
                <div *ngIf="activeTab === 'account'" class="account-section">
                    <div class="settings-card account-card">
                        <div class="form-group-container boxed">
                            <div class="form-group">
                                <label>Mobile Number</label>
                                <div class="input-with-icon">
                                    <input type="text" [(ngModel)]="userInfo.mobile">
                                    <span class="edit-icon">
                                        <img src="assets/icons/penciledit.svg" alt="Edit" width="20" height="20">
                                    </span>
                                </div>
                                <div class="validation-error" *ngIf="validationErrors['mobile']">{{
                                    validationErrors['mobile'] }}</div>
                                <p class="helper-text">Linked to OTP verification and security alerts.</p>
                            </div>
                            <div class="account-id-row">
                                <span class="label">Account ID</span>
                                <span class="value">{{ userInfo.accountId }}</span>
                            </div>
                        </div>

                        <div class="form-group mt-32">
                            <label>Email Address</label>
                            <div class="input-with-icon">
                                <input type="email" [(ngModel)]="userInfo.email">
                                <span class="edit-icon">
                                    <img src="assets/icons/penciledit.svg" alt="Edit" width="20" height="20">
                                </span>
                            </div>
                            <div class="validation-error" *ngIf="validationErrors['email']">{{ validationErrors['email']
                                }}</div>
                        </div>

                        <div class="form-group mt-32">
                            <label>Birthday</label>
                            <div class="input-with-icon focused">
                                <input type="text" [(ngModel)]="userInfo.birthday">
                                <span class="edit-icon">
                                    <img src="assets/icons/calendar.svg" alt="Calendar" width="20" height="20">
                                </span>
                            </div>
                            <div class="validation-error" *ngIf="validationErrors['birthday']">{{
                                validationErrors['birthday'] }}</div>
                        </div>
                    </div>

                    <!-- Account Actions -->
                    <div class="settings-card action-card">
                        <div class="action-row">
                            <div class="action-info">
                                <h3>Log out of all devices</h3>
                                <p>Sign out from all active sessions.</p>
                            </div>
                            <button class="btn btn-logout-black" (click)="logoutAllDevices()">Log out</button>
                        </div>
                    </div>

                    <div class="settings-card action-card">
                        <div class="action-row">
                            <div class="action-info">
                                <h3>Delete your account</h3>
                                <p>Permanently remove your account and associated data.</p>
                            </div>
                            <button class="btn btn-delete-red" (click)="deleteAccount()">Delete</button>
                        </div>
                    </div>
                </div>

                <!-- Notifications Tab -->
                <div *ngIf="activeTab === 'notifications'" class="notifications-section">
                    <div class="settings-card notifications-card">
                        <div class="notif-category">
                            <h3>General</h3>
                            <div class="toggle-row">
                                <div class="toggle-info">
                                    <h4>Payments</h4>
                                    <p>Get notified about successful payments, failed transactions, and refunds.</p>
                                </div>
                                <div class="toggle-switch" [class.active]="notifications.payments"
                                    (click)="toggleNotification('payments')">
                                    <div class="switch-handle"></div>
                                </div>
                            </div>
                        </div>

                        <div class="notif-category">
                            <div class="category-separator"></div>
                            <h3>Credit Card</h3>
                            <div class="toggle-row">
                                <div class="toggle-info">
                                    <h4>Bills & Due Reminders</h4>
                                    <p>Receive reminders for upcoming bills, recharges, and due dates.</p>
                                </div>
                                <div class="toggle-switch" [class.active]="notifications.bills"
                                    (click)="toggleNotification('bills')">
                                    <div class="switch-handle"></div>
                                </div>
                            </div>
                            <div class="toggle-row border-top">
                                <div class="toggle-info">
                                    <h4>Credit Card Alerts</h4>
                                    <p>Stay updated on bill generation, payment due dates, and card activity.</p>
                                </div>
                                <div class="toggle-switch" [class.active]="notifications.ccAlerts"
                                    (click)="toggleNotification('ccAlerts')">
                                    <div class="switch-handle"></div>
                                </div>
                            </div>
                            <div class="category-separator"></div>
                            <div class="toggle-row">
                                <div class="toggle-info">
                                    <h4>Loan Alerts</h4>
                                    <p>Get alerts for EMI schedules, upcoming payments, and loan updates.</p>
                                </div>
                                <div class="toggle-switch" [class.active]="notifications.loans"
                                    (click)="toggleNotification('loans')">
                                    <div class="switch-handle"></div>
                                </div>
                            </div>
                            <div class="category-separator"></div>
                            <div class="toggle-row">
                                <div class="toggle-info">
                                    <h4>Critical Alerts</h4>
                                    <p>Essential security and regulatory notifications. These cannot be disabled.</p>
                                </div>
                                <div class="toggle-switch active semi-opaque">
                                    <div class="switch-handle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Banks Tab -->
                <div *ngIf="activeTab === 'banks'" class="banks-section">
                    <div class="settings-card banks-card">
                        <div class="bank-list">
                            <div *ngFor="let bank of connectedBanks" class="bank-item"
                                [class.disconnected]="bank.status === 'disconnected'">
                                <div class="bank-logo">
                                    <img [src]="bank.logo" [alt]="bank.name">
                                </div>
                                <div class="bank-separator"></div>
                                <div class="bank-details-wrapper">
                                    <div class="bank-details">
                                        <h3>{{ bank.name }}</h3>
                                        <p *ngIf="bank.status === 'connected'">Connected on {{ bank.connectedDate }}</p>
                                        <p *ngIf="bank.status === 'disconnected'">Disconnect on {{ bank.connectedDate }}
                                        </p>
                                    </div>
                                    <button *ngIf="bank.status === 'connected'" class="btn-disconnect"
                                        (click)="openDisconnectModal(bank)">Disconnect</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Footer Actions (Cancel/Save) -->
                <div class="main-footer-actions">
                    <button class="btn btn-cancel-main" (click)="goBack()">Cancel</button>
                    <button class="btn btn-save-main" (click)="saveSettings()">Save</button>
                </div>
            </div>
        </main>
    </div>

    <!-- Modal: Photo Crop -->
    <div class="modal-overlay dark" *ngIf="showCropModal" (click)="closeCropModal()">
        <div class="modal-content crop-modal" (click)="$event.stopPropagation()">
            <div class="modal-header">
                <h3>Crop photo</h3>
                <button class="btn-close" (click)="closeCropModal()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>

            <div class="crop-area-container">
                <div class="crop-frame-wrapper">
                    <div class="crop-frame" (mousedown)="startDrag($event)" (mousemove)="onDrag($event)"
                        (mouseup)="stopDrag()" (mouseleave)="stopDrag()" (touchstart)="startDrag($event)"
                        (touchmove)="onDrag($event)" (touchend)="stopDrag()">
                        <div class="circle-overlay"></div>
                        <img #sourceImage [src]="selectedImage" alt="Crop target"
                            [style.transform]="'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + imageScale + ')'">
                    </div>
                </div>

                <div class="slider-column">
                    <div class="slider-ruler">
                        <div class="ruler-tick"
                            *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21]">
                        </div>
                    </div>
                    <div class="slider-container">
                        <input type="range" min="1" max="3" step="0.01" [value]="imageScale"
                            (input)="onScaleChange($event)" class="crop-slider">
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-modal-delete" (click)="closeCropModal()">Delete</button>
                    <button class="btn btn-modal-crop" (click)="confirmCrop()">Crop</button>

                    <!-- Hidden canvas for actual cropping -->
                    <canvas #cropCanvas hidden></canvas>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal: Disable Bank Access -->
    <div class="modal-overlay" *ngIf="showDisconnectModal" (click)="closeDisconnectModal()">
        <div class="modal-content disconnect-modal" (click)="$event.stopPropagation()">
            <div class="modal-content-inner">
                <div class="modal-icon-badge">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 21h18M3 10h18M3 10l9-7 9 7M4 10v11M20 10v11M8 14v3M12 14v3M16 14v3"></path>
                    </svg>
                </div>
                <h2>Disable Bank Access?</h2>
                <p>We will stop fetching data from {{ selectedBankToDisconnect?.name }}. You can reconnect anytime.
                </p>
            </div>
            <div class="modal-actions-row">
                <button class="btn btn-modal-disable" (click)="confirmDisconnect()">Disable Access</button>
                <button class="btn btn-modal-cancel" (click)="closeDisconnectModal()">Cancel</button>
            </div>
        </div>
    </div>
</div>